import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const NavBarPage = () => {
  const { navBarApi } = apiPath;
  const [navBar, navLoading] = useFetch(navBarApi);

  if (navLoading) {
    return <Loading />;
  }
  const { navLogo } = navBar;
  const data = [
    {
      elementType: "file",
      label: "Navbar Logo",
      type: "file",
      name: "navLogo",
      defaultValue: navLogo,
      multiple: false,
      required: true,
    },
  ];

  const update = (data) => {
    updateData(navBarApi, data);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default NavBarPage;
